import { render, staticRenderFns } from "./ReportFromRSPItem.vue?vue&type=template&id=10b1909f&scoped=true&"
import script from "./ReportFromRSPItem.vue?vue&type=script&lang=js&"
export * from "./ReportFromRSPItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportFromRSPItem.vue?vue&type=style&index=0&id=10b1909f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b1909f",
  null
  
)

export default component.exports